import React, { useState, useEffect } from "react";
import { Container } from "./styles";
import { Button, Form, Input, Select, Spin, Upload } from "antd";
import { toast } from "react-toastify";
import ContentBlockEditor from "../../components/ContentBlockEditor";
import { useNavigate, useParams } from "react-router-dom";
import {
  ArrowLeftOutlined,
  EditOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { useLanguage } from "../../hooks/LanguageContext";
import api from "../../services/api";
import { returnCatch } from "../../services/functions";

const { Option } = Select;

export default function NutritionForm() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [error, setError] = useState(false);
  const [contents, setContents] = useState([]);
  const [photo, setPhoto] = useState("");
  const [contentsDelete, setContentsDelete] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams();
  const { language } = useLanguage();
  const isEditing = !!id;

  useEffect(() => {
    if (id) {
      loadingScreen(id);
    } else {
      setLoading(false);
    }
  }, [id]);

  async function loadingScreen() {
    setLoading(true);
    await api
      .get(`/admin/nutrition/${id}`)
      .then((response) => {
        form.setFieldsValue({
          title: response.data.title,
          meal_type: response.data.meal_type,
          calories: response.data.calories,
          phase: response.data.phase,
          duration: response.data.duration,
        });
        setContents(response.data.contents);
        setPhoto({ photo_url: response.data.photo_url });
      })
      .catch(({ response }) => {
        returnCatch(response);
      });
    setLoading(false);
  }

  async function handleSubmit(values) {
    if (!photo || contents.some((item) => !item.value)) {
      toast.warn("Preencha todos os campos e envie uma imagem de capa");
      setError(true);
    } else {
      setLoadingButton(true);
      if (isEditing) {
        await editedNutrition(values);
      } else {
        await createdNutrition(values);
      }
      setLoadingButton(false);
    }
  }

  async function createdNutrition(values) {
    const data = new FormData();

    const contentsFile = contents.filter((item) => {
      return item.type == "IMAGE" || item.type == "VIDEO";
    });
    const contentsText = contents.filter((item) => {
      return item.type != "IMAGE" && item.type != "VIDEO";
    });

    data.append("title", values.title);
    data.append("meal_type", values.meal_type);
    data.append("calories", values.calories);
    data.append("phase", values.phase);
    data.append("duration", values.duration);
    data.append("language", language);
    data.append("contents", JSON.stringify(contentsText));
    if (photo.name) {
      data.append("file", photo, photo.name);
    }

    await api
      .post("/admin/nutrition", data)
      .then(async (response) => {
        let error = "";
        Promise.all(
          await contentsFile.map(async (item) => {
            const data = new FormData();
            console.log(item);
            data.append("order", item.order);
            data.append("type", item.type);
            data.append("nutrition_id", id);
            if (item.value.name) {
              data.append("file", item.value, item.value.name);
            }
            await api
              .post(`/admin/content-nutrition`, data)
              .then(() => {})
              .catch(({ response }) => {
                error = error
                  ? `, posição ${item.idx}`
                  : `, mas não foi possivel criar o conteudo da posição ${item.idx}`;
              });
          }),
        );
        toast({
          type: error ? "warning" : "success",
          message: "Receita criada com sucesso",
        });
        navigate(`/nutritions/edit/${response.data.id}`);
      })
      .catch(({ response }) => {
        returnCatch(response);
      });
  }

  async function editedNutrition(values) {
    const data = new FormData();

    const contentsFile = contents.filter((item) => {
      return item.type == "IMAGE" || item.type == "VIDEO";
    });
    const contentsText = contents.filter((item) => {
      return item.type != "IMAGE" && item.type != "VIDEO";
    });

    data.append("title", values.title);
    data.append("meal_type", values.meal_type);
    data.append("calories", values.calories);
    data.append("phase", values.phase);
    data.append("duration", values.duration);
    data.append("language", language);
    data.append("contents", JSON.stringify(contentsText));
    data.append("contentsDelete", JSON.stringify(contentsDelete));
    if (photo.name) {
      data.append("file", photo, photo.name);
    }

    await api
      .put(`/admin/nutrition/${id}`, data)
      .then(async (response) => {
        let error = "";
        await Promise.all(
          await contentsFile.map(async (item) => {
            const data = new FormData();

            data.append("order", item.order);
            data.append("type", item.type);
            if (item.value.name) {
              data.append("file", item.value, item.value.name);
            }

            if (item.id) {
              await api
                .put(`/admin/content-nutrition/${item.id}`, data)
                .then(() => {})
                .catch(({ response }) => {
                  error = error
                    ? `${error}, ${item.order + 1}`
                    : `, mas não foi possivel criar/editar o conteudo da posição ${item.order + 1}`;
                });
            } else {
              data.append("nutrition_id", id);
              await api
                .post(`/admin/content-nutrition`, data)
                .then(() => {})
                .catch(({ response }) => {
                  error = error
                    ? `${error}, ${item.order + 1}`
                    : `, mas não foi possivel criar/editar o conteudo da posição ${item.order + 1}`;
                });
            }
          }),
        );
        if (error) {
          toast.warning("Receita editada com sucesso" + error);
        } else {
          toast.success("Receita editada com sucesso");
        }

        navigate(`/nutritions/edit/${response.data.id}`);
      })
      .catch(({ response }) => {
        returnCatch(response);
      });
  }

  return (
    <Container>
      <div style={{ maxWidth: 800, width: "100%" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 15,
            marginBottom: 20,
          }}
        >
          <Button
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate("/nutritions")}
            shape="circle"
          />
          <h1 style={{ margin: 0 }}>
            {isEditing ? "Editar Receita" : "Nova Receita"}
          </h1>
        </div>
        {loading ? (
          <Spin />
        ) : (
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            style={{
              background: "#fff",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "10px 20px",
              }}
            >
              <Form.Item
                label="Imagem de Capa"
                style={{
                  width: "100%",
                  marginBottom: 0,
                }}
                required
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  {photo && (
                    <img
                      draggable={false}
                      src={photo.photo_url}
                      alt="avatar"
                      style={{
                        width: 150,
                        borderRadius: 10,
                        height: 150,
                        marginRight: 15,
                      }}
                    />
                  )}
                  <Upload
                    name="avatar"
                    listType="picture-card"
                    className="avatar-uploader"
                    showUploadList={false}
                    maxCount={1}
                    onRemove={() => {
                      setPhoto(null);
                    }}
                    beforeUpload={(currentFile) => {
                      const isImage = currentFile.type.startsWith("image/");
                      if (!isImage) {
                        toast.error(
                          "Você só pode carregar arquivos de imagem!",
                        );
                        return Upload.LIST_IGNORE;
                      }

                      currentFile.photo_url = URL.createObjectURL(currentFile);
                      setPhoto(currentFile);

                      console.log(currentFile);
                      return false;
                    }}
                    fileList={photo ? [photo] : []}
                  >
                    <div
                      style={{
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <PlusOutlined />
                      <div style={{ marginTop: 8 }}>
                        {photo ? "Editar" : "Adicionar"}
                      </div>
                    </div>
                  </Upload>
                </div>
              </Form.Item>
              <Form.Item
                name="title"
                label="Título"
                rules={[{ required: true, message: "Insira o título da capa" }]}
                style={{
                  marginBottom: 0,
                  width: "100%",
                }}
              >
                <Input
                  placeholder="Ex: Benefícios do Ferro"
                  size="large"
                  style={{
                    width: "100%",
                  }}
                />
              </Form.Item>
              <Form.Item
                name="meal_type"
                label="Tipo da Refeição"
                rules={[
                  { required: true, message: "Selecione o tipo da refeição" },
                ]}
                style={{
                  marginBottom: 0,
                  flex: 1,
                }}
              >
                <Select
                  placeholder="Ex: Menstrual"
                  size="large"
                  style={{ minWidth: 300 }}
                >
                  <Option value="Café da manhã">Café da manhã</Option>
                  <Option value="Lanche">Lanche</Option>
                  <Option value="Almoço">Almoço</Option>
                  <Option value="Jantar">Jantar</Option>
                  <Option value="Sobremesa">Sobremesa</Option>
                  <Option value="Suco">Suco</Option>
                </Select>
              </Form.Item>
              <Form.Item
                name="phase"
                label="Fase do ciclo"
                rules={[{ required: true, message: "Insira a fase do ciclo" }]}
                style={{
                  marginBottom: 0,
                  flex: 1,
                }}
              >
                <Select
                  placeholder="Ex: Menstrual"
                  size="large"
                  style={{ minWidth: 300 }}
                >
                  <Option value="MENSTRUAL">Menstrual</Option>
                  <Option value="FOLICULAR">Folicular</Option>
                  <Option value="OVULATORIA">Ovulátoria</Option>
                  <Option value="LUTEA">Lutea</Option>
                </Select>
              </Form.Item>
              <Form.Item
                name="calories"
                label="Calorias"
                rules={[{ required: true, message: "Insira as calorias" }]}
                style={{
                  marginBottom: 0,
                  flex: 1,
                }}
              >
                <Input
                  placeholder="Ex: 100kcal"
                  size="large"
                  style={{ minWidth: 300 }}
                />
              </Form.Item>
              <Form.Item
                name="duration"
                label="Duração"
                rules={[{ required: true, message: "Insira o duração" }]}
                style={{
                  marginBottom: 0,
                  flex: 1,
                }}
              >
                <Input
                  placeholder="Ex: 20min"
                  size="large"
                  style={{ minWidth: 300 }}
                />
              </Form.Item>
            </div>

            <ContentBlockEditor
              blocks={contents}
              error={error}
              setBlocks={setContents}
              removeBlock={(id, index) => {
                setContents(contents.filter((block, idx) => index !== idx));
                if (id) {
                  setContentsDelete([...contentsDelete, id]);
                }
              }}
            />

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 40,
                gap: 15,
              }}
            >
              <Button size="large" onClick={() => navigate("/nutritions")}>
                Cancelar
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                loading={loadingButton}
                size="large"
              >
                {isEditing ? "Salvar Alterações" : "Criar Receita"}
              </Button>
            </div>
          </Form>
        )}
      </div>
    </Container>
  );
}
